<div class="loader-spinner">
    <p-progressSpinner strokeWidth="3"
    animationDuration="1s" />
</div>
